module.exports = __webpack_public_path__ + "img/targe-detection.97c34c1a.png";